"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _detail = _interopRequireDefault(require("./detail.vue"));
var _group = require("@/api/group");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    activityDetail: _detail.default
  },
  data: function data() {
    return {
      tableData: [],
      formData: {
        groupActivityName: '',
        productName: '',
        merName: '',
        recordStatus: '10',
        startTime: '',
        endTime: '',
        limit: 20,
        page: 1,
        content: '',
        searchType: 'all'
      },
      total: 0,
      hedaList: [],
      time: ''
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:groupbuy:record:list'])) this.getList();
  },
  methods: {
    search: function search() {
      this.formData.page = 1;
      this.getList();
    },
    handleClick: function handleClick(tab, event) {
      this.formData.page = 1;
      this.getList();
    },
    timeChange: function timeChange(e) {
      this.formData.page = 1;
      if (e) {
        this.formData.startTime = e[0];
        this.formData.endTime = e[1];
      } else {
        this.formData.startTime = '';
        this.formData.endTime = '';
      }
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      (0, _group.groupRecordList)(this.formData).then(function (res) {
        _this.tableData = res.list;
        _this.total = res.total;
        _this.getCount();
      });
    },
    getCount: function getCount() {
      var _this2 = this;
      (0, _group.groupRecordCount)(this.formData).then(function (res) {
        _this2.hedaList = res;
      });
    },
    //详情
    toDeatil: function toDeatil(row) {
      var _this3 = this;
      (0, _group.groupRecordInfo)(row.groupBuyingId).then(function (res) {
        _this3.$refs.detail.data = res;
        _this3.$refs.detail.dialogVisible = true;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.limit = val;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.formData.page = page;
      this.getList();
    },
    //重置
    reset: function reset() {
      this.formData.groupActivityName = '';
      this.formData.productName = '';
      this.formData.merName = '';
      this.formData.startTime = '';
      this.formData.endTime = '';
      this.formData.page = 1;
      this.formData.content = '';
      this.formData.searchType = 'all';
      this.time = '';
      this.getList();
    }
  }
};